
/*
 * modify cloudinary image url to transform to smaller size and quality
 * TODO: this is lifted directly from checkout and has mixed concerns && 
 * only handles auto width with given height:
 *   break it down.
 *   add functionality
 */
/**  Makes url strings secure
 *
 * @param { string } imageUrl url string
 * @param { string, Number } height for the new image

 * @returns { string } secure image url or original input if not a valid string
 */
export function resize(imageUrl, height = '125') {
  if(!imageUrl || typeof imageUrl !== 'string') return imageUrl;
  let newUrl = imageUrl.replace('res.cloudinary.com/sofaworks', 'images.sofology.co.uk');

  if (newUrl.indexOf('images.sofology.co.uk') !== -1) {
    const filter = `c_pad,q_70,h_${height},fl_lossy,f_auto`;
    newUrl = newUrl.replace('image/upload', '');

    const parts = newUrl.toLowerCase().split('images.sofology.co.uk');
    parts[0] += `images.sofology.co.uk/${filter}`;
    return parts.join('').replace('http://', 'https://');
  }
  return newUrl;
}


/**  Makes url strings secure
 *
 * @param { string } imageUrl url string
 *
 * @returns { string } secure image url or original input if not a valid string
 */
export function makeSafe(imageUrl) {
  if(!imageUrl || typeof imageUrl !== 'string') return imageUrl;

  if (imageUrl.includes('http://')) {
    return imageUrl.replace('http://', 'https://');
  }
  return imageUrl;
}



// WEBPACK FOOTER //
// ./src/services/cloudinaryService.js